// Action Type for Manage License

// Get Licenses subscription list
import {
  GET_LICENSES_SUBSCRIPTION_LIST,
  GET_LICENSES_SUBSCRIPTION_LIST_FAILURE,
  GET_LICENSES_SUBSCRIPTION_LIST_SUCCESS,
  GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST,
  GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_FAILURE,
  GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_SUCCESS,
  REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW,
  REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_SUCCESS,
  REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_FAILURE,
  CONFIRM_SUBSCRIPTION_LICENSES_ORDER,
  CONFIRM_SUBSCRIPTION_LICENSES_ORDER_SUCCESS,
  CONFIRM_SUBSCRIPTION_LICENSES_ORDER_FAILURE,
  UPDATE_SUBSCRIPTION_LICENSES_ORDER,
  UPDATE_SUBSCRIPTION_LICENSES_ORDER_SUCCESS,
  UPDATE_SUBSCRIPTION_LICENSES_ORDER_FAILURE,
  UNASSIGN_LICENSE_FROM_USER,
  UNASSIGN_LICENSE_FROM_USER_SUCCESS,
  UNASSIGN_LICENSE_FROM_USER_FAILURE,
  GET_SUBSCRIPTION_PRODUCT_LIST,
  GET_SUBSCRIPTION_PRODUCT_LIST_SUCCESS,
  GET_SUBSCRIPTION_PRODUCT_LIST_FAILURE,
  GET_USER_LICENCE_LIST,
  GET_USER_LICENCE_LIST_SUCCESS,
  GET_USER_LICENCE_LIST_FAILURE,
} from "./actionType";

export const getLicensesSubscriptionList = () => ({
  type: GET_LICENSES_SUBSCRIPTION_LIST,
});

// Get Licenses subscription list success
export const getLicensesSubscriptionListSuccess = (data) => ({
  type: GET_LICENSES_SUBSCRIPTION_LIST_SUCCESS,
  payload: data,
});

// Get Licenses subscription list failure
export const getLicensesSubscriptionListFailure = (data) => ({
  type: GET_LICENSES_SUBSCRIPTION_LIST_FAILURE,
  payload: data,
});

export const getLicensesSubscriptionProductList = () => ({
  type: GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST,
});

// Get Licenses subscription list success
export const getLicensesSubscriptionProductListSuccess = (data) => ({
  type: GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_SUCCESS,
  payload: data,
});

// Get Licenses subscription list failure
export const getLicensesSubscriptionProductListFailure = (data) => ({
  type: GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_FAILURE,
  payload: data,
});

// Request Subscription Licenses Order Preview
export const requestSubscriptionLicensesOrderPreview = (data) => ({
  type: REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW,
  payload: data,
});

// Request Subscription Licenses Order Preview success
export const requestSubscriptionLicensesOrderPreviewSuccess = (data) => ({
  type: REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_SUCCESS,
  payload: data,
});

// Request Subscription Licenses Order Preview failure
export const requestSubscriptionLicensesOrderPreviewFailure = (data) => ({
  type: REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_FAILURE,
  payload: data,
});

// Confirm Subscription Licenses Order
export const confirmSubscriptionLicensesOrder = (data) => ({
  type: CONFIRM_SUBSCRIPTION_LICENSES_ORDER,
  payload: data,
});

// Confirm Subscription Licenses Order success
export const confirmSubscriptionLicensesOrderSuccess = (data) => ({
  type: CONFIRM_SUBSCRIPTION_LICENSES_ORDER_SUCCESS,
  payload: data,
});

// Confirm Subscription Licenses Order failure
export const confirmSubscriptionLicensesOrderFailure = (data) => ({
  type: CONFIRM_SUBSCRIPTION_LICENSES_ORDER_FAILURE,
  payload: data,
});

// Update Subscription Licenses Order
export const updateSubscriptionLicensesOrder = (data) => ({
  type: UPDATE_SUBSCRIPTION_LICENSES_ORDER,
  payload: data,
});

// Update Subscription Licenses Order success
export const updateSubscriptionLicensesOrderSuccess = (data) => ({
  type: UPDATE_SUBSCRIPTION_LICENSES_ORDER_SUCCESS,
  payload: data,
});

// Update Subscription Licenses Order failure
export const updateSubscriptionLicensesOrderFailure = (data) => ({
  type: UPDATE_SUBSCRIPTION_LICENSES_ORDER_FAILURE,
  payload: data,
});

// Unassign License from user
export const unassignLicenseFromUser = (data) => ({
  type: UNASSIGN_LICENSE_FROM_USER,
  payload: data,
});

// Unassign License from user success
export const unassignLicenseFromUserSuccess = (data) => ({
  type: UNASSIGN_LICENSE_FROM_USER_SUCCESS,
  payload: data,
});

// Unassign License from user failure
export const unassignLicenseFromUserFailure = (data) => ({
  type: UNASSIGN_LICENSE_FROM_USER_FAILURE,
  payload: data,
});

// Get Subscription Product List
export const getSubscriptionProductList = () => ({
  type: GET_SUBSCRIPTION_PRODUCT_LIST,
});

// Get Subscription Product List success
export const getSubscriptionProductListSuccess = (data) => ({
  type: GET_SUBSCRIPTION_PRODUCT_LIST_SUCCESS,
  payload: data,
});

// Get Subscription Product List failure
export const getSubscriptionProductListFailure = (data) => ({
  type: GET_SUBSCRIPTION_PRODUCT_LIST_FAILURE,
  payload: data,
});

// Get all licences held by a single user (staff profile CRM Licence tab)
export const getUserLicenceList = (userId) => ({
  type: GET_USER_LICENCE_LIST,
  payload: userId,
});

// Get user licence list success
export const getUserLicenceListSuccess = (data) => ({
  type: GET_USER_LICENCE_LIST_SUCCESS,
  payload: data,
});

// Get user licence list failure
export const getUserLicenceListFailure = (data) => ({
  type: GET_USER_LICENCE_LIST_FAILURE,
  payload: data,
});
